import React from 'react';
import dayjs from 'dayjs';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';

const PickupTimeBanner = ({ pickuptime, store, timezone }) => {
  if (!pickuptime) return null;

  const formatted = store?.timezoneid
    ? dayjs(pickuptime)
        .tz(store.timezoneid)
        .format('ddd, MM/DD/YYYY [at] hh:mm A')
    : dayjs(pickuptime)
        .utc()
        .utcOffset((timezone || 0) * 60)
        .format('ddd, MM/DD/YYYY [at] hh:mm A');

  return (
    <div className="reveal flex items-start gap-3 rounded-md border border-amber-200 bg-amber-50 p-4 dark:border-amber-900/50 dark:bg-amber-900/15">
      <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">
        <CalendarDaysIcon className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-amber-700 dark:text-amber-400">
          Scheduled Order
        </p>
        <p className="mt-0.5 text-sm font-semibold text-amber-900 dark:text-amber-200">
          {formatted}
        </p>
      </div>
    </div>
  );
};

export default PickupTimeBanner;
